export enum FileDisplayType {
    PREVIEW_BLOCKS = 'preview_blocks',
    LIST = 'list',
    LIST_PRINT = 'list_print',
    LIST_PREVIEW = 'list_preview'
}